<template>
	<div>
		<el-container class="navpage">
			<el-main style="padding: 0 10px;">
				<div class="text-left">
					<el-button type="warning" size="mini" @click="toUpDir" :disabled="path ? false : true">
						返回上级目录
						<span v-if="path">({{ path }})</span>
					</el-button>
					<el-button type="primary" size="mini" @click="dialogVisible = true">上传文件</el-button>
				</div>
				<el-table
					:data="fileList"
					style="width: 100%;margin-bottom: 20px;"
					row-key=""
					:stripe="true"
					tooltip-effect="dark"
					ref="multipleTable"
					@row-click="fileRowClick"
					:row-style="{ cursor: 'pointer' }"
				>
					<el-table-column prop="filename" label="模板文件名">
						<template slot-scope="scope">
							<i :class="scope.row.filetype == 'dir' ? 'el-icon-folder-opened' : 'el-icon-document'"></i>
							{{ scope.row.filename }}
						</template>
					</el-table-column>
					<el-table-column prop="filetype" label="文件类型"></el-table-column>
					<el-table-column prop="createtime" label="创建时间"></el-table-column>
					<el-table-column prop="changetime" label="修改时间"></el-table-column>
					<el-table-column label="操作" width="220">
						<template slot-scope="scope">
							<template v-if="scope.row.filetype != 'dir'">
								<el-button type="warning" size="mini" @click="openFile(scope.row)">修改</el-button>
								<el-button type="success" size="mini" @click="copyFile(scope.row)">复制</el-button>
								<el-button type="danger" size="mini" @click="tempFileDelete(scope.row)">删除</el-button>
							</template>
						</template>
					</el-table-column>
				</el-table>
			</el-main>
		</el-container>
		<el-dialog title="上传文件" :visible.sync="dialogVisible" width="80%" style="text-align: left;" :close-on-click-modal="false">
			<el-upload
				ref="fileupload"
				class="upload-demo"
				drag
				:action="HOST + '/admin.files/uploadTemplateFile'"
				:data="{ adminid: JSON.parse($store.state.user.userInfo).id, token: JSON.parse($store.state.user.userInfo).token, path: path, filename: uploadname }"
				:on-success="file => fileUploaded(file, '')"
				:on-remove="file => fileRemove(file, '')"
				:auto-upload="false"
			>
				<i class="el-icon-upload"></i>
				<div class="el-upload__text">
					将文件拖到此处，或
					<em>点击上传</em>
				</div>
			</el-upload>
			<el-row style="line-height: 40px;margin-top: 20px;">
				<el-col :span="3">重命名</el-col>
				<el-col :span="9"><el-input v-model="uploadname" type="text" placeholder="选填,请勿带有中文路径"></el-input></el-col>
			</el-row>
			<div slot="footer" class="dialog-footer text-center">
				<el-button type="success" @click="uploadFile">确 定</el-button>
				<el-button type="warning" @click="dialogVisible = false">关闭窗口</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
export default {
	name: 'fileManage',
	data() {
		return {
			fileList: [],
			path: '',
			dialogVisible: false,
			uploadname: ''
		};
	},
	mounted() {
		this.getDirFile();
	},
	activated() {
		if(this.$store.state.auth.pageRefresh){
			this.getDirFile();
			this.setPageRefresh(false);
		}
	},
	methods: {
		...mapMutations({
			setPageRefresh: 'auth/setPageRefresh'
		}),
		getDirFile(path='') {
			this.$axios({
				url: this.HOST + '/admin.files/searchDirFile',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					path: path?path:this.path
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.path = path?path:this.path;
						console.log(this.path);
						this.fileList = res.data;
					}
				})
				.catch(err => {});
		},
		addModel(scope) {
			if (scope) {
				this.$router.push({ path: '/documentModel/addModel', query: { mid: scope.mid } });
			} else {
				this.$router.push({ path: '/documentModel/addModel', query: { mid: '' } });
			}
		},
		toUpDir() {
			let patharr = this.path.split('/');
			patharr.pop();
			this.path = patharr.join('/');
			console.log(this.path);
			this.getDirFile();
		},
		fileRowClick(row, column, event) {
			console.log(row.filename);
			if (row.filetype == 'dir') {
				let path = this.path + '/' + row.filename;
				this.getDirFile(path);
			}
		},
		openFile(scope) {
			let path = this.path + '/' + scope.filename;
			this.$router.push({ path: '/templateManage/fileEdit', query: { filepath: path } });
		},
		copyFile(scope) {
			// let path = this.path + '/' + scope.filename;
			this.$router.push({ path: '/templateManage/fileCopy', query: { filepath: this.path, filename: scope.filename } });
		},
		uploadFile() {
			this.$refs.fileupload.submit();
		},
		// 文件上传回调
		fileUploaded(file, name) {
			console.log(file, name);
			if (file.length) {
				this.$message.success('文件上传成功');
				this.$refs.fileupload.clearFiles();
				this.dialogVisible = false;
				this.getDirFile();
			} else {
				this.$message.error('文件格式不支持，请重试');
				this.$refs.fileupload.clearFiles();
			}
		},
		// 图片移除
		fileRemove(file, name) {
			console.log(file, name);
		},
		// 文件删除
		tempFileDelete(scope) {
			console.log(scope);
			this.$confirm('是否要删除模板文件？此操作一经删除不可恢复！')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.files/deleteFile',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							filepath: this.path,
							filename: scope.filename
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.$message.success(res.data.msg);
								this.getDirFile();
							}
						})
						.catch(err => {});
				})
				.catch(() => {});
		}
	}
};
</script>
<style lang="scss">
.el-main {
	padding: 0;
	.navpage {
		min-height: calc(100vh - 161px);
		.aside-primary {
			width: 240px;
			height: 100%;
			background-color: #ecf5ff;
			// height: 100%;
			padding: 20px;
			.el-divider__text {
				background-color: #ecf5ff;
				padding: 0 2px;
				font-size: 13px;
			}
			.el-menu-parent {
				background-color: transparent;
				.el-submenu {
					margin-bottom: 10px;
					background-color: #fff;
				}
				.el-menu-item {
					height: 45px;
					line-height: 45px;
					margin-bottom: 10px;
					background-color: #fff;
					min-width: 180px;
				}
			}
		}
		.width240 {
			width: 240px !important;
			transition: 0.8s;
		}
		.width0 {
			width: 0 !important;
		}
		.color-green {
			color: green;
		}
		.color-red {
			color: #ff2f4b;
		}
		.el-dropdown {
			margin: 0 10px;
		}
		.el-button + .el-button-group {
			margin-left: 10px;
			margin-right: 10px;
		}
	}
}
</style>
